import { render } from "./SidebarLogo.vue?vue&type=template&id=b6699834&scoped=true&ts=true"
import script from "./SidebarLogo.vue?vue&type=script&lang=ts"
export * from "./SidebarLogo.vue?vue&type=script&lang=ts"

import "./SidebarLogo.vue?vue&type=style&index=0&id=b6699834&lang=scss&scoped=true"

import exportComponent from "/builds/gh_prod_devops/gh_prod_devops_web/lpoa_prod_deploy/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6699834"]])

export default __exports__